export default "__VITE_ASSET__Uzb9aGZ0__"